/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  contain: content;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  height: calc(28rem/14);
}

:host(:focus) {
  outline: none;
}

.container {
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  height: calc(28rem/14);
  width: calc(70rem/14);
  border-radius: 1rem;
}

.knob {
  display: block;
  position: absolute;
  top: calc(3rem/14);
  height: calc(22rem/14);
  width: calc(22rem/14);
  border-radius: 50%;
  background-color: #FFFFFF;
  background-color: var(--davinci-color-white, #FFFFFF);
}

.icon {
  position: absolute;
  top: calc(-1rem/14);
  opacity: 1;
}
.icon > davinci-icon, .icon davinci-icon-small {
  fill: #FFF;
  fill: var(--davinci-color-text-on-secondary, #FFF);
}
.icon.grey > davinci-icon, .icon davinci-icon-small {
  fill: #FFF;
  fill: var(--davinci-color-text-on-secondary-light, #FFF);
}
.icon.darkgrey > davinci-icon, .icon davinci-icon-small {
  fill: #FFF;
  fill: var(--davinci-color-text-on-secondary-dark, #FFF);
}

.container,
.knob,
.icon {
  -webkit-transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
}

:host(:not([checked])) .container {
  background-color: #505F6B;
  background-color: var(--davinci-color-secondary-light, #505F6B);
}
:host(:not([checked])) .knob {
  left: calc(4rem/14);
}
:host(:not([checked])) .icon {
  left: calc(32rem/14);
}
:host(:not([checked])) .iconOn {
  opacity: 0;
}

:host([checked]) .container {
  background-color: #323C43;
  background-color: var(--davinci-color-secondary, #323C43);
}
:host([checked]) .knob {
  left: calc(44rem/14);
}
:host([checked]) .icon {
  left: calc(-34rem/14);
}
:host([checked]) .iconOff {
  opacity: 0;
}

:host([checked][blue]) .container {
  background-color: #007CC1;
  background-color: var(--davinci-color-primary, #007CC1);
}

:host([disabled]) {
  pointer-events: none;
  cursor: default;
}
:host([disabled]) .container {
  background-color: var(--davinci-color-outline-disabled,#D2D9DD) !important;
}`;
export { style };
//# sourceMappingURL=ToggleSwitch.style.js.map